import { connect } from "react-redux";

// Component
import DashBoardNew from "./DashBoardNew";
// Actions
import {
  getDashboardAttendance,
  getDashboardCompleteJobCompare,
  getDashboardCustomerPerformance,
  getDashboardEstimation,
  getDashboardJobInfoCustom,
  getDashboardOperationTopSection,
  getDashboardOrganizationJobs,
  getDashboardOrganizationSales,
  getDashboardPerformers,
  getDashboardProjectCount,
  getDashboardRevenue,
  getDashboardServiceTopSection,
  getDashboardRecentCompletedJobs,
  getDashboardTimesheetCount,
} from "./dashBoardNewActions";

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  profileData: state.profile.profileData,

  jobsCustomIsloading: state.dashboard.jobsInfoCustomIsloading,
  jobsCustom: state.dashboard.jobsInfoCustom,
  attendanceIsLoading: state.dashboard.attendanceIsLoading,
  attendanceData: state.dashboard.attendanceData,
  revenueIsLoading: state.dashboard.revenueIsLoading,
  lastYearRevenue: state.dashboard.lastYearRevenue,
  thisYearRevenue: state.dashboard.thisYearRevenue,
  currentMonthIndex: state.dashboard.currentMonthIndex,
  completeJobCompareIsLoading: state.dashboard.completeJobCompareIsLoading,
  lastYearCompleteJobCompare: state.dashboard.lastYearCompleteJobCompare,
  thisYearCompleteJobCompare: state.dashboard.thisYearCompleteJobCompare,
  completeJobCompareCurrentMonthIndex:
    state.dashboard.completeJobCompareCurrentMonthIndex,
  performersIsLoading: state.dashboard.performersIsLoading,
  topPerformers: state.dashboard.topPerformers,
  estimationIsLoading: state.dashboard.estimationIsLoading,
  estimationData: state.dashboard.estimationData,
  topCustomersIsLoading: state.dashboard.customerPerformanceIsLoading,
  topCustomers: state.dashboard.customerPerformanceData,
  organizationSalesIsLoading: state.dashboard.organizationSalesIsLoading,
  organizationSalesData: state.dashboard.organizationSalesData,
  organizationJobsIsLoading: state.dashboard.organizationJobsIsLoading,
  organizationJobsData: state.dashboard.organizationJobsData,
  projectCountIsLoading: state.dashboard.projectCountIsLoading,
  projectCountData: state.dashboard.projectCountData,
  timesheetCountIsLoading: state.dashboard.timesheetCountIsLoading,
  timesheetCountData: state.dashboard.timesheetCountData,
  serviceTopSectionIsLoading: state.dashboard.serviceTopSectionIsLoading,
  serviceTopSectionData: state.dashboard.serviceTopSectionData,
  operationTopSectionIsLoading: state.dashboard.operationTopSectionIsLoading,
  operationTopSectionData: state.dashboard.operationTopSectionData,
  recentCompletedJobsIsLoading: state.dashboard.recentCompletedJobsIsLoading,
  recentCompletedJobsData: state.dashboard.recentCompletedJobsData,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getJobInfoCustom: details =>
    dispatch(getDashboardJobInfoCustom({ ...details })),
  getDashboardAttendance: details =>
    dispatch(getDashboardAttendance({ ...details })),
  getDashboardPerformers: details =>
    dispatch(getDashboardPerformers({ ...details })),
  getDashboardRevenue: details => dispatch(getDashboardRevenue({ ...details })),
  getDashboardCompleteJobCompare: details =>
    dispatch(getDashboardCompleteJobCompare({ ...details })),
  getDashboardTopCustomers: details =>
    dispatch(getDashboardCustomerPerformance({ ...details })),
  getDashboardEstimation: details =>
    dispatch(getDashboardEstimation({ ...details })),
  getDashboardOrganizationSales: details =>
    dispatch(getDashboardOrganizationSales({ ...details })),
  getDashboardOrganizationJobs: details =>
    dispatch(getDashboardOrganizationJobs({ ...details })),
  getDashboardProjectCount: details =>
    dispatch(getDashboardProjectCount({ ...details })),
  getDashboardOperationTopSection: details =>
    dispatch(getDashboardOperationTopSection({ ...details })),
  getDashboardRecentCompletedJobs: details =>
    dispatch(getDashboardRecentCompletedJobs({ ...details })),
  getDashboardTimesheetCount: details =>
    dispatch(getDashboardTimesheetCount({ ...details })),
  getDashboardServiceTopSection: details =>
    dispatch(getDashboardServiceTopSection({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(DashBoardNew);
